import L from 'leaflet'
import { GestureHandling } from 'leaflet-gesture-handling'

// le hook doit être posé avant toute création de carte, sinon l'option
// gestureHandling est ignorée sur les instances déjà construites
L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling)

export default class Maps {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const container = this.el.querySelector('.maps--container')
    if (!container) return

    const lat = parseFloat(container.dataset.lat)
    const lng = parseFloat(container.dataset.lng)
    if (isNaN(lat) || isNaN(lng)) return

    const zoom = parseInt(container.dataset.zoom, 10) || 14

    const map = L.map(container, {
      gestureHandling: true,
      scrollWheelZoom: true,
    }).setView([lat, lng], zoom)

    // tuiles OSM standard : gratuites, sans clé API — CARTO (utilisé avant)
    // exige désormais une clé sur son offre gratuite de fonds de carte
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_330i_1_03de84502c4f166b585b87f7', {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20,
    }).addTo(map)

    const icon = L.divIcon({
      className: 'maps--marker',
      html: `<svg width="45" height="58" viewBox="0 0 45 58" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.9923 20.7364C44.6949 9.76911 35.3551 0.638925 23.7832 0.0335799C10.7714 -0.648092 0 9.13745 0 21.2996C0 25.1712 1.08964 28.7954 2.9993 31.9116L19.8304 56.6202C21.0841 58.4599 23.9277 58.4599 25.1814 56.6202L42.0014 31.9116C44.0027 28.6454 45.1035 24.8185 44.9923 20.7364ZM22.4962 31.6879C16.4169 31.6879 11.4941 27.0188 11.4941 21.2707C11.4941 15.5225 16.4169 10.8403 22.4962 10.8403C28.5754 10.8403 33.5038 15.5146 33.5038 21.2707C33.5038 27.0267 28.5809 31.6879 22.4962 31.6879Z" fill="currentColor"/></svg>`,
      iconSize: [45, 58],
      iconAnchor: [22, 58],
    })

    L.marker([lat, lng], { icon }).addTo(map)

    // Lenis peut décaler le calcul de taille au premier rendu
    setTimeout(() => map.invalidateSize(), 200)
  }
}
